/* eslint-disable react/prop-types */
import React from 'react'

import { Typography, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'

import CloseIcon from '@mui/icons-material/Close'

const StyledTitleBar = styled('div')({
  display: 'flex',
  justifyContent: 'space-between'
})

const StyledOnlyIconBar = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end'
})

const StyledTitleHeadings = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingBottom: theme.spacing(2)
}))

const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  color: theme.palette.primary.main
}))

interface IProps {
  title?: string
  onClose: () => void
}

const DialogTitle = (props: IProps) => {
  const { title, onClose } = props

  const Bar = title ? StyledTitleBar : StyledOnlyIconBar

  return (
    <Bar>
      {title ? (
        <StyledTitleHeadings>
          <Typography variant="h3">{title}</Typography>
        </StyledTitleHeadings>
      ) : null}
      <div>
        <StyledCloseButton aria-label="Close" onClick={onClose} size="large">
          <CloseIcon />
        </StyledCloseButton>
      </div>
    </Bar>
  )
}

export default DialogTitle
